import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { TicketDetailPage } from '../features/tickets/TicketDetailPage';

function TicketDetailRoute() {
  const { ticketId } = Route.useParams();
  return (
    <RequireRole allow={['admin']}>
      <TicketDetailPage ticketId={ticketId} />
    </RequireRole>
  );
}

export const Route = createFileRoute('/tickets/$ticketId')({
  component: TicketDetailRoute,
});
